import { render, staticRenderFns } from "./landing-page.vue?vue&type=template&id=0c320d68&scoped=true&"
import script from "./landing-page.vue?vue&type=script&lang=js&"
export * from "./landing-page.vue?vue&type=script&lang=js&"
import style0 from "./landing-page.vue?vue&type=style&index=0&id=0c320d68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c320d68",
  null
  
)

export default component.exports